///<reference path="../../../../typings/index.d.ts"/>


module Meevo.Components.ShortCuts {
    angular.module('meevo.components.short-cuts', ['cfp.hotkeys'])
    .config(['hotkeysProvider', hotkeysProvider => {
        hotkeysProvider.template = '<div ng-include="\'app/components/short-cuts/directives/cheatSheetTemplate.html\'" on-load="hotkeys = hotkeys">';
    }]);
}